import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const MonitorPoliciesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help-policies", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Subscriber Monitor Policies"
      onClose={doClose}
      content={() => (
        <>
          <p>
            Subscriber monitoring policies. Define actions to take on a
            subscriber basis. Subscribers are identified as a unique access-side
            IP address.{" "}
          </p>
          <ul>
            <li>
              <b>UDR</b>: Percentage of monitorings generating UDR (Usage Data
              Record). Used by DPI reporting.
            </li>
            <li>
              <b>ACTIONS</b>: Allowed operations on this policy (e.g. delete or
              edit).
            </li>
          </ul>
          <p>
            Click on the <i class="material-icons valign-icon">delete</i> icon
            to delete an already configured policy.
          </p>
          <p>
            Press the <i class="material-icons valign-icon">more_vert</i> icon
            and then select the <b>Add Policy...</b> option to add a new Policy.
          </p>
          <p>
            Click on the <i class="material-icons valign-icon">refresh</i> icon
            to refresh policies information.
          </p>
        </>
      )}
      onClose={doClose}
    />
  );
};
export default MonitorPoliciesHelpModal;
